<template>
  <div class="d-flex flex-column">
    <v-select
      dense
      outlined
      hide-details
      item-value="id"
      item-text="name"
      v-model="selectedChallengeId"
      :loading="isLoading"
      :items="challenges"
      :label="$t('common.challenge_one')"
      :menu-props="{ offsetY: true, maxWidth: '320px' }"
      @input="assignChallenge"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click.native.stop>
          <v-list-item-content>
            <v-text-field
              dense
              outlined
              hide-details
              append-icon="mdi-magnify"
              v-model="searchTerms"
              :placeholder="$t('common.search_challenge')"
              @input="onSearchChanged"
            >
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'ChallengeSelector',

  mixins: [mixin],

  props: {
    organizationId: {
      type: String,
      required: true,
    },
    location: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      modalOpen: false,
      isLoading: false,
      selectedChallengeId: '',
      challenges: [],
      searchTerms: '',
    }
  },

  mounted() {
    this.getAllChallenges()
  },

  methods: {
    ...mapActions({
      getChallenges: 'getChallenges',
    }),

    async getAllChallenges(searchTerms) {
      this.isLoading = true

      try {
        const params = {
          filters: { status: 'active' },
          sort: {
            by: 'updatedAt',
            order: 'desc',
          },
        }

        if (searchTerms) {
          params.terms = searchTerms
          params.sort.by = '_score'
        } else {
          params.filters.sites = [this.location?.site?._id]
        }

        const response = await this.getChallenges({
          organizationId: this.organizationId,
          ...params,
        })

        this.challenges = response?.results ?? []
      } catch (err) {
        this.showError(this.$t('error.challenge.no_challenges_available'))
      } finally {
        this.isLoading = false
      }
    },

    onSearchChanged: _.debounce(async function() {
      this.getAllChallenges(this.searchTerms)
    }, 200),

    assignChallenge(value) {
      this.selectedChallengeId = value
      this.$emit('onChallengeSelection', this.selectedChallengeId)
    },
  },
}
</script>
